import { render, staticRenderFns } from "./BrandContentSlider.vue?vue&type=template&id=2512c75b&scoped=true&"
import script from "./BrandContentSlider.vue?vue&type=script&lang=js&"
export * from "./BrandContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./BrandContentSlider.vue?vue&type=style&index=0&id=2512c75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512c75b",
  null
  
)

export default component.exports